import { Box, Text } from '@chakra-ui/react'
import { remoteAssessmentField } from '@hb/shared'
import { FormElement } from '../../../../components/forms'
import { SectionLabel } from '../../SectionLabel'

// §2.1 Non-Routine + Telehealth: Remote Assessment section.
// Replaces General Illness Exam when a non-routine visit uses a telehealth modality.
// All fields are optional — patient-reported values, availability varies.
export const RemoteAssessmentInput = () => (
  <Box w="100%" data-child-name="data.remoteAssessment" px={5} py="14px">
    <SectionLabel>Remote Assessment</SectionLabel>
    <Box
      mb={3}
      px={3}
      py={2}
      bg="blue.50"
      _dark={{ bg: 'blue.900' }}
      borderLeft="3px solid"
      borderColor="blue.400"
      borderRadius={4}>
      <Text fontSize="sm" color="blue.700" _dark={{ color: 'blue.200' }} fontWeight={500}>
        Patient self-reported — not provider-measured.
      </Text>
      <Text fontSize="xs" color="blue.600" _dark={{ color: 'blue.300' }} mt={0.5}>
        Document only what the patient was able to provide. All fields are optional.
      </Text>
    </Box>
    <FormElement root showName={false} field={remoteAssessmentField} name="data.remoteAssessment" />
  </Box>
)
